import type { FC } from "react";

import { MONO_LABEL_CLASS_NAME } from "./landingPrimitives";
import { PublicHeaderBrand } from "./PublicHeader";

const FOOTER_COLUMNS = [
  {
    links: [
      { href: "/#models", label: "Models" },
      { href: "/#actors", label: "Actors" },
      { href: "/#skill-mesh", label: "Skill Mesh" },
      { href: "/billing", label: "Pricing" },
    ],
    title: "Product",
  },
  {
    links: [
      { href: "/#auth", label: "Request access" },
      { href: "/login", label: "Sign in" },
    ],
    title: "Get started",
  },
] as const;

const FooterColumn: FC<{ column: (typeof FOOTER_COLUMNS)[number] }> = ({
  column,
}) => (
  <div>
    <p className={`${MONO_LABEL_CLASS_NAME} text-slate-500`}>{column.title}</p>
    <ul className="mt-4 space-y-3">
      {column.links.map((link) => (
        <li key={link.href}>
          <a
            href={link.href}
            className="text-sm text-slate-300 transition hover:text-white"
          >
            {link.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export const PublicFooter: FC = () => (
  <footer className="relative border-t border-slate-800 px-4 pb-10 pt-14 sm:px-6">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:justify-between">
      <div className="max-w-sm space-y-4">
        <PublicHeaderBrand />
        <p className="text-sm leading-6 text-slate-400">
          Persistent AI teammates that remember, work in their own sandboxes and
          cost nothing while parked.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-10 sm:gap-16">
        {FOOTER_COLUMNS.map((column) => (
          <FooterColumn key={column.title} column={column} />
        ))}
      </div>
    </div>
    <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-2 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row sm:justify-between">
      <span>Arti is built by VaultN.</span>
      <span className="font-mono uppercase tracking-[0.16em]">
        Spawn once · Keep forever
      </span>
    </div>
  </footer>
);
